import { cn } from 'v5/platform/dom/cn';

/** Person silhouette for an avatar slot of a resource with no name and no picture; fills the slot and sits on its bottom edge. */
export function ResourceAvatarSilhouette({
  className
}: {
  className?: string;
}) {
  return (
    <svg
      viewBox="0 0 100 100"
      aria-hidden
      className={cn('size-full self-end fill-current opacity-40', className)}
    >
      <circle cx="50" cy="38" r="20" />
      <path d="M10 100c0-24 18-38 40-38s40 14 40 38z" />
    </svg>
  );
}
